import React from 'react';
import { SignupEmailSection, TitleArea, Title, Description, EmailInputBlock, InputStyle, DeleteButton, DeleteIcon, ErrorBlock, ErrorIcon, ErrorMessage } from './style';
import warningIcon from 'images/warning.png';
import cancelIcon from 'images/icon/close_btn_grey_circle-18x18.png'

const SignupEmailScene = ({onChange, email, errorMsg}) => {
    const errorClassName = errorMsg ? 'error_active' : null;
    return (
        <SignupEmailSection>
            <TitleArea>
                <Title>{'이메일 주소를 입력해 주세요'}</Title>
                <Description>{`자주 쓰는 이메일을 입력해 주세요 (상품 수령을 위해)`}</Description>
            </TitleArea>
            <EmailInputBlock>
                <InputStyle className={errorClassName} type='email' onChange={(e)=>{if(onChange)onChange(e.target.value);}} value={email} placeholder='이메일 주소 입력' />
                {email.length >= 2 ? (
                    <DeleteButton onClick={() => {if(onChange) onChange('')}}>
                        <DeleteIcon src={cancelIcon} />
                    </DeleteButton>
                ) : null}
            </EmailInputBlock>
            {errorMsg ? (
                <ErrorBlock>
                    <ErrorIcon src={warningIcon}/>
                    <ErrorMessage>{errorMsg}</ErrorMessage>
                </ErrorBlock>
            ) : null}
        </SignupEmailSection>
    );
}

export default SignupEmailScene;